import { render } from "./BaseCheckbox.vue?vue&type=template&id=12100a52&scoped=true"
import script from "./BaseCheckbox.vue?vue&type=script&lang=js"
export * from "./BaseCheckbox.vue?vue&type=script&lang=js"

import "./BaseCheckbox.vue?vue&type=style&index=0&id=12100a52&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-12100a52"

export default script